import { useMemo } from 'react';

import { Breadcrumbs } from '@dbt-labs/sourdough';

import { Page } from '@/components/Page';
import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useValidatedParams } from '@/hooks/params';
import {
  useProjectBreadcrumbs,
  useResourceTypeBreadcrumb,
} from '@/hooks/useBreadcrumbs';
import { getResourceTypeName } from '@/util/resourceType';
import { ExposureFilterView } from './components/FilterPages/ExposureFilterView';
import { GroupFilterView } from './components/FilterPages/GroupFilterView';
import { MacroFilterView } from './components/FilterPages/MacroFilterView';
import { MetricFilterView } from './components/FilterPages/MetricFilterView';
import { ModelFilterView } from './components/FilterPages/ModelFilterView';
import { SavedQueryFilterView } from './components/FilterPages/SavedQueryFilterView';
import { SeedFilterView } from './components/FilterPages/SeedFilterView';
import { SemanticModelFilterView } from './components/FilterPages/SemanticModelFilterView';
import { SnapshotFilterView } from './components/FilterPages/SnapshotFilterView';
import { SourceCollectionFilterView } from './components/FilterPages/SourceCollectionFilterView';
import { TestFilterView } from './components/FilterPages/TestFilterView';

export const ResourceFilterPage = () => {
  const { resourceType } = useValidatedParams();
  const { accountId } = useDbtCloudProject();

  const resourceTypeString = resourceType || '';

  const resourceTypeBreadcrumb = useResourceTypeBreadcrumb({
    resourceType: resourceTypeString,
    includeLink: true,
  });

  const pageTitle = getResourceTypeName(resourceTypeString);

  const additionalItems = useMemo(() => {
    if (!resourceTypeBreadcrumb) return [];
    return [resourceTypeBreadcrumb];
  }, [resourceTypeBreadcrumb]);

  const breadcrumbs = useProjectBreadcrumbs({
    additionalItems,
  });

  if (!resourceType || !accountId) return null;
  return (
    <Page title={pageTitle} pageType="resourceFilter">
      <Breadcrumbs className="mb-3" breadcrumbs={breadcrumbs} />
      {resourceType === 'model' && <ModelFilterView />}
      {resourceType === 'seed' && <SeedFilterView />}
      {resourceType === 'source' && <SourceCollectionFilterView />}
      {resourceType === 'exposure' && <ExposureFilterView />}
      {resourceType === 'macro' && <MacroFilterView />}
      {resourceType === 'snapshot' && <SnapshotFilterView />}
      {resourceType === 'test' && <TestFilterView />}
      {resourceType === 'group' && <GroupFilterView />}
      {resourceType === 'semantic_model' && <SemanticModelFilterView />}
      {resourceType === 'saved_query' && <SavedQueryFilterView />}
      {resourceType === 'metric' && <MetricFilterView />}
    </Page>
  );
};
